<div class="header-text">Activity at Time of Incident</div>
<div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-2 mt-3 mb-4">
    <div class="col">
        <div class="checkbox-group p-2">
            <dx-check-box text="Driving Equipment" [(value)]="incidentReport.isDrivingEquipment"></dx-check-box>
            <dx-check-box text="Lifting" [(value)]="incidentReport.isLifting" class="mt-2 d-block"
                [readOnly]="isReadOnly"></dx-check-box>
            <dx-check-box text="Climbing" [(value)]="incidentReport.isClimbing" class="mt-2 d-block"
                [readOnly]="isReadOnly"></dx-check-box>
            <dx-check-box text="Standing" [(value)]="incidentReport.isStanding" class="mt-2 d-block"
                [readOnly]="isReadOnly"></dx-check-box>
            <dx-check-box text="Running" [(value)]="incidentReport.isRunning" class="mt-2 d-block"
                [readOnly]="isReadOnly"></dx-check-box>
        </div>
    </div>
    <div class="col">
        <div class="checkbox-group p-2">
            <dx-check-box text="Carrying" [(value)]="incidentReport.isCarrying" [readOnly]="isReadOnly"></dx-check-box>
            <dx-check-box text="Sitting" [(value)]="incidentReport.isSitting" class="mt-2 d-block"
                [readOnly]="isReadOnly"></dx-check-box>
            <dx-check-box text="Laying Down" [(value)]="incidentReport.isLayingDown" class="mt-2 d-block"
                [readOnly]="isReadOnly"></dx-check-box>
            <dx-check-box text="Walking" [(value)]="incidentReport.isWalking" class="mt-2 d-block"
                [readOnly]="isReadOnly"></dx-check-box>
        </div>
    </div>
    <div class="col">
        <div class="checkbox-group p-2">
            <dx-check-box text="Pushing/Pulling" [(value)]="incidentReport.isPushingOrPulling"
                [readOnly]="isReadOnly"></dx-check-box>
            <dx-check-box text="Kneeling" [(value)]="incidentReport.isKneeling" class="mt-2 d-block"
                [readOnly]="isReadOnly"></dx-check-box>
            <dx-check-box text="Stretching/Reclining" [(value)]="incidentReport.isStretchingOrReclining"
                class="mt-2 d-block" [readOnly]="isReadOnly"></dx-check-box>
            <dx-check-box text="Other" [(value)]="incidentReport.isOther" class="mt-2 d-block"
                [readOnly]="isReadOnly"></dx-check-box>
        </div>
    </div>
</div>
<div class="row row-cols-1 row-cols-md-3 row-cols-lg-5 g-3">
    @if (incidentReport.isDrivingEquipment) {
        <div class="col">
            <label class="form-label">Equipment: <span class="text-danger">*</span></label>
            <dx-text-box stylingMode="filled" [(value)]="incidentReport.equipment" maxLength="100"
                [readOnly]="isReadOnly"> 
                <dx-validator>
                    <dxi-validation-rule max="100" type="required"
                        message="Equipment name is required">
                    </dxi-validation-rule>
                </dx-validator>
            </dx-text-box>
        </div>
    }
    @if (incidentReport.isLifting) {
        <div class="col">
            <label class="form-label">Lifting (lbs): <span class="text-danger">*</span></label>
            <dx-text-box stylingMode="filled" [(value)]="incidentReport.lifting" maxLength="100" [readOnly]="isReadOnly">
                <dx-validator>
                    <dxi-validation-rule max="100" type="required"
                        message="Lifting weight is required">
                    </dxi-validation-rule>
                </dx-validator>
            </dx-text-box>
        </div>
    }
    @if (incidentReport.isCarrying) {
        <div class="col">
            <label class="form-label">Carrying (lbs): <span class="text-danger">*</span></label>
            <dx-text-box stylingMode="filled" [(value)]="incidentReport.carrying" maxLength="100"  [readOnly]="isReadOnly">
                <dx-validator>
                    <dxi-validation-rule max="100" type="required"
                        message="Carrying weight is required">
                    </dxi-validation-rule>
                </dx-validator>
            </dx-text-box>
        </div>
    }
    @if (incidentReport.isPushingOrPulling) {
        <div class="col">
            <label class="form-label">Pushing/Pulling (lbs): <span class="text-danger">*</span></label>
            <dx-text-box stylingMode="filled" [(value)]="incidentReport.pushingOrPulling" maxLength="100"
                [readOnly]="isReadOnly"> 
                <dx-validator>
                    <dxi-validation-rule max="100" type="required"
                        message="Pushing/Pulling weight is required"></dxi-validation-rule>
                </dx-validator>
            </dx-text-box>
        </div>
    }
    @if (incidentReport.isOther) {
        <div class="col">
            <label class="form-label">Other – specify: <span class="text-danger">*</span></label>
            <dx-text-box stylingMode="filled" [(value)]="incidentReport.other" maxLength="100"
                [readOnly]="isReadOnly">
                <dx-validator>
                    <dxi-validation-rule max="100" type="required"
                        message="Other specification is required"></dxi-validation-rule>
                </dx-validator>
            </dx-text-box>
        </div>
    }
</div>